export function getAbsoluteDomainUrl(): string {
  if (window
    && "location" in window
    && "protocol" in window.location
    && "host" in window.location) {
    return window.location.protocol + "//" + window.location.host;
  }
  return null;
}
